import Vue from 'vue'
import App from './App.vue'
import Notifications from 'vue-notification'
import VueI18n from 'vue-i18n';
import { VLazyImagePlugin } from "v-lazy-image";
import Datetime from 'vue-datetime';

import 'animate.css/animate.min.css';
import 'vue-datetime/dist/vue-datetime.css';


require('intersection-observer');

IntersectionObserver.prototype.POLL_INTERVAL = 100;

Vue.use(Notifications);
Vue.use(VLazyImagePlugin);
Vue.use(Datetime);
Vue.use(VueI18n);

const messages = window.editorTranslate;
const i18n = new VueI18n({
  locale: 'en_US',
  fallbackLang: 'en_US',
  messages
});


Vue.config.productionTip = false

new Vue({
  render: h => h(App), i18n,
}).$mount('#app')



window.mergeRecursive = function (obj1, obj2) {

  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor == Object) {
        obj1[p] = window.mergeRecursive(obj1[p], obj2[p]);

      } else {
        obj1[p] = obj2[p];

      }

    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];

    }
  }

  return obj1;
}
